import api from 'api';

export const CUSTOM_INGREDIENTS_ASYNC_ACTION_START = 'CUSTOM_INGREDIENTS_ASYNC_ACTION_START';
export const CUSTOM_INGREDIENTS_ASYNC_ACTION_ERROR = 'CUSTOM_INGREDIENTS_ASYNC_ACTION_ERROR';
export const CUSTOM_INGREDIENTS_ASYNC_ACTION_SUCCESS = 'CUSTOM_INGREDIENTS_ASYNC_ACTION_SUCCESS';
export const CUSTOM_INGREDIENTS_RESET_STATE = 'CUSTOM_INGREDIENTS_RESET_STATE';

function customIngredientsAsyncActionStart() {
  return {
    type: CUSTOM_INGREDIENTS_ASYNC_ACTION_START,
  };
}

function customIngredientsAsyncActionError(error) {
  return {
    type: CUSTOM_INGREDIENTS_ASYNC_ACTION_ERROR,
    error,
  };
}

function customIngredientsAsyncActionSuccess(data) {
  return {
    type: CUSTOM_INGREDIENTS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetCustomIngredientsState() {
  return {
    type: CUSTOM_INGREDIENTS_RESET_STATE,
  };
}

export function getCustomIngredients(brandId, ingredType) {
  return (dispatch, getState) => {
    dispatch(customIngredientsAsyncActionStart());
    return api.request(`ingredient/listByType?brandId=${brandId}&ingredType=${ingredType}`, 'get')
    .then((data) => {
      dispatch(customIngredientsAsyncActionSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(customIngredientsAsyncActionError('Unable to get custom ingredients'));
      throw(error);
    });
  };
}
